import { useRef } from 'react'
import { Select } from '@/components/ds2'

/** A compact filter dropdown for the box-truck driver lists — the design-system ds2 Select (not a raw
 *  <select>), width-constrained so several sit inline in the toolbar. The first option is the "… : All" reset
 *  (value ''); selecting it clears the filter. */
export const BoxTruckFilterSelect = ({
    value,
    onChange,
    options,
    className = 'w-44',
    onFirstOpen,
}: {
    value: string
    onChange: (value: string) => void
    options: { label: string; value: string }[]
    className?: string
    /**
     * Fired once, the first time the operator reaches for this dropdown — for options that cost a server
     * round trip to build and that most page opens never look at.
     *
     * It hangs off the wrapper rather than the `Select`, because `Select` mirrors the component library's
     * prop API and giving this one surface a prop the library does not have is how a port stops being one.
     * Pointer-down and focus both fire BEFORE the panel opens, so the fetch is already in flight by the time
     * there is a list to fill.
     */
    onFirstOpen?: () => void
}) => {
    const asked = useRef(false)
    const ask = () => {
        if (asked.current) return
        asked.current = true
        onFirstOpen?.()
    }
    return (
        <div className={className} onPointerDownCapture={ask} onFocusCapture={ask}>
            <Select value={value} onChange={onChange} options={options} placeholder={options[0]?.label} />
        </div>
    )
}
